import { getApiBaseUrl, apiRequest } from './apiClient';

/* Şifremi unuttum (SMS) — public uçlar + yönetici link uçları */

const publicBase = () => `${getApiBaseUrl()}/api/public/sifre-sifirlama`;

async function readJsonSafe(res) {
  try {
    return await res.json();
  } catch {
    if (res.status === 429) return { mesaj: 'Çok fazla istek yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.' };
    if (res.status >= 500) return { mesaj: 'Sunucuya şu an ulaşılamıyor. Lütfen biraz sonra tekrar deneyin.' };
    return {};
  }
}

async function publicFetch(path, body, varsayilanHata) {
  let res;
  try {
    res = await fetch(`${publicBase()}${path}`, body === undefined
      ? undefined
      : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  } catch {
    throw new Error('İnternet bağlantınızı kontrol edip tekrar deneyin.');
  }
  const json = await readJsonSafe(res);
  if (!res.ok) {
    const err = new Error(json.mesaj || varsayilanHata);
    err.status = res.status;
    throw err;
  }
  return json;
}

const t = (token) => `/${encodeURIComponent(token)}`;

export const fetchSifreLinkDurumu = (token) => publicFetch(t(token), undefined, 'Bağlantı yüklenemedi');
export const fetchSifreTeknikServisler = (token) =>
  publicFetch(`${t(token)}/teknik-servisler`, undefined, 'Servis listesi yüklenemedi');
export const sifreServisSec = (token, techServiceId) =>
  publicFetch(`${t(token)}/servis`, { techServiceId }, 'Servis bilgisi alınamadı');
export const sifreKodGonder = (token, techServiceId, telefon) =>
  publicFetch(`${t(token)}/kod-gonder`, { techServiceId, telefon }, 'Kod gönderilemedi');
export const sifreKodDogrula = (token, payload) =>
  publicFetch(`${t(token)}/kod-dogrula`, payload, 'Doğrulama yapılamadı');
export const sifreBelirle = (token, payload) =>
  publicFetch(`${t(token)}/sifre-belirle`, payload, 'Şifre değiştirilemedi');

/* Yönetici */
export const fetchSifreLinkSecenekleri = () => apiRequest('/api/sifre-sifirlama-linkleri/secenekler', { method: 'GET' });
export const fetchSifreLinkleri = ({ sayfa = 1, limit = 20 } = {}) =>
  apiRequest(`/api/sifre-sifirlama-linkleri?sayfa=${sayfa}&limit=${limit}`, { method: 'GET' });
export const createSifreLink = (sureMs) =>
  apiRequest('/api/sifre-sifirlama-linkleri', { method: 'POST', body: { sureMs } });
export const updateSifreLinkGecerlilik = (id, sureMs) =>
  apiRequest(`/api/sifre-sifirlama-linkleri/${encodeURIComponent(id)}/gecerlilik`, { method: 'PATCH', body: { sureMs } });
export const pasifAlSifreLink = (id) =>
  apiRequest(`/api/sifre-sifirlama-linkleri/${encodeURIComponent(id)}/pasif`, { method: 'POST' });
